import React, { useEffect, useRef, useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Box from "@mui/material/Box";
import { GridColDef, GridPinnedColumnFields } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import {
    Button,
    IconButton,
    Popper,
    TextField,
    Badge,
    MenuItem,
    Menu,
    Stack,
    Tooltip
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid2";
import Chip from "@mui/material/Chip";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { ThreeDot } from "react-loading-indicators";
import emptyImage from "../../assets/images/image.png";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { DataGridPro } from "@mui/x-data-grid-pro";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
    getCompanyRfqMetaFilterData,
    getCustomerRfqData,
    getCustomerRfqDataV1
} from "../Services/OrgRepo";
import { CertificationDrawer } from "./CertificationDrawer";
import { Link, useNavigate } from "react-router-dom";
import {
    accountManager,
    accountManagerHead,
    NPDManagerHead,
    generateCompanyLogo,
    generatProfilePicUrl,
    getLoggedInEmail,
    getLoggedInUserID,
    isSourcingManagerHead,
    Management,
    productionManagerHead,
    qualityManagerHead,
    sourcingManager,
    sourcingManagerHead,
    formatCurrencyValue
} from "../../Utils/Constant";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EuroIcon from "@mui/icons-material/Euro";
import oligasIcn from "../../assets/icons/oligas.png";
import evAutoIcn from "../../assets/icons/automotive.png";
import power from "../../assets/icons/power.png";
import industry from "../../assets/icons/industry.png";
import aerospace from "../../assets/icons/aerospace.png";
import defaultlogo from "../../assets/icons/noimg.png";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CircleIcon from "@mui/icons-material/Circle";

import { setFips } from "crypto";
import { CertificationDrawerInReview } from "./CertificationDrawerInreview";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import dayjs from "dayjs";

export const CustomerRfqOR = () => {
    const [value, setValue] = React.useState("1");
    const [searchTerm, setSearchTerm] = useState("");
    const [rows, setRows] = useState<string[]>([]);
    const [filteredRows, setFilteredRows] = useState(rows);
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const [selectedRowsForAcceptAndReject, selSelectedRowsForAcceptAndReject] =
        useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedIndustry, setSelectedIndustry] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState([]);
    const [selectedMarginRange, setSelectedMarginRange] = useState([]);
    const [selectedKeyAccountManager, setSelectedKeyAccountManager] = useState(
        []
    );
    const [filteredSelectedIndustry, setFilteredSelectedIndustry] = useState(
        []
    );
    const [filteredSelectedStatus, setFilteredSelectedStatus] = useState([]);
    const [filteredSelectedCompany, setFilteredSelectedCompany] = useState([]);
    const [filteredSelectedMarginRange, setFilteredSelectedMarginRange] =
        useState([]);
    const [
        filteredSelectedKeyAccountManager,
        setFilteredSelectedKeyAccountManager
    ] = useState([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isFilterLoading, setIsFilterLoading] = useState<boolean>(false);
    const searchInputRef = useRef<HTMLInputElement>(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [filterOptions, setFilterOptions] = useState<{
        [key: string]: { title: string; value: string }[];
    }>({});
    const [isApplyFilter, setIsApplyFilter] = useState<Boolean>(false);
    const [readNew, setNewRead] = useState<Boolean>(false);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [maxWidth, setMaxWidth] =
        React.useState<DialogProps["maxWidth"]>("xs");
    const [isButtonDisable, setIsButtonDisable] = useState<boolean>(false);
    const [reasonForRejection, setReasonForRejection] = useState<string>("");
    const [removeFilter, setRemoveFilter] = useState<boolean>(false);
    const popperRef = useRef<HTMLDivElement>(null);
    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 10 // Default page size
    });
    const navigate = useNavigate();

    const [pinnedColumns, setPinnedColumns] =
        React.useState<GridPinnedColumnFields>({
            left: ["rfqID", "rfqName"],
            right: ["status"]
        });
    const handlePinnedColumnsChange = React.useCallback(
        (updatedPinnedColumns: GridPinnedColumnFields) => {
            setPinnedColumns(updatedPinnedColumns);
        },
        []
    );

    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setReasonForRejection("");
    };

    const handleOpenDrawer = async (row: any) => {
        setSelectedRow(row);
        setOpenDrawer(true);
    };

    const handleCloseDrawer = () => {
        setOpenDrawer(false);
    };

    const fetchCustomerRfqData = async (params: string) => {
        setIsLoading(true);
        setNewRead(false);
        try {
            let paylod = {};

            paylod = {
                userEmail: getLoggedInEmail(),
                status: "In Review"
            };

            const response = await getCustomerRfqDataV1(paylod);
            setIsLoading(false);
            if (response?.status) {
                let data = response?.data?.map((item: any, index: number) => ({
                    id: index + 1, // DataGrid requires a unique `id` field
                    rfqID: item?.rfqID || `P${index + 1}`, // Generate an ID if missing
                    rfqName: item?.rfqName || "-",
                    companyName: item?.companyName || "-",
                    marginRange: item?.marginRange || "-",
                    partDetails: item?.listOfParts || "-",
                    totalOrderValue: item?.totalOrderValue || "-",
                    preferredCurrency: item?.preferredCurrency || "-",
                    industryType: item?.industryType || "-",
                    mandatoryCertifications:
                        item?.mandatoryCertifications.join(", "),
                    incoTerms: item?.incoTerms || "-",
                    keyAccountManager: `${item?.keyAccountManager || "-"}`,
                    keyAccountManagerFilePath: item?.keyAccountManagerFilePath,
                    keyAccountManagerID: item?.keyAccountManagerID,
                    emailId: item?.Primary_Contact_Email || "-",
                    Added_Date: item?.Added_Date || "-",
                    pricetype: item?.pricetype || "-",
                    addedOn: item?.addedOn || "-",
                    lastUpdateOn: item?.lastUpdateOn || "-",
                    type_of_order: item?.type_of_order || "",
                    status: item?.status,
                    coRfqID: item?.ID,
                    isNew: item?.isNew,
                    companyID: item?.companyID,
                    companyRecId: item?.companyRecId,
                    companyLogo: item?.companyLogo,
                    ID: item?.ID,
                    rfqStartDate: item?.rfqStartDate,
                    rfqEndDate: item?.rfqEndDate
                }));
                setRows(data);
                setFilteredRows(data);
            } else {
                setRows([]);
                setFilteredRows([]);
            }
        } catch (error) {
            setIsLoading(false);
            setRows([]);
            setFilteredRows([]);
        }
    };
    const [isInitialRender, setIsInitialRender] = useState(true);

    useEffect(() => {
        // if (isInitialRender) {
        //   setIsInitialRender(false); // Mark as rendered
        //   return; // Skip first execution
        // }
        // const fetchdataInUseEffect = async () => {
        fetchCustomerRfqData(getLoggedInUserID());
        setAnchorEl(null);
        setSelectedIndustry([]);
        setSelectedMarginRange([]);
        setSelectedCompany([]);
        setSelectedKeyAccountManager([]);
        setSelectedStatus([]);
        // };
        // fetchdataInUseEffect();
    }, []);

    const handleClearAll = () => {
        setSelectedIndustry([]);
        setSelectedMarginRange([]);
        setSelectedCompany([]);
        setSelectedKeyAccountManager([]);
        setSelectedStatus([]);
    };
    const handleClearAllChip = () => {
        setSelectedIndustry([]);
        setSelectedMarginRange([]);
        setSelectedCompany([]);
        setSelectedKeyAccountManager([]);
        setSelectedStatus([]);
        setFilteredSelectedCompany([]);
        setFilteredSelectedIndustry([]);
        setFilteredSelectedKeyAccountManager([]);
        setFilteredSelectedMarginRange([]);
        setFilteredSelectedStatus([]);
        setFilteredRows(rows);
        setIsApplyFilter(false);
    };
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (Object.keys(filterOptions).length === 0) {
            fetchFilterData();
        }
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedIndustry(filteredSelectedIndustry);
        setSelectedMarginRange(filteredSelectedMarginRange);
        setSelectedCompany(filteredSelectedCompany);
        setSelectedKeyAccountManager(filteredSelectedKeyAccountManager);
        setSelectedStatus(filteredSelectedStatus);
    };

    // Handle search input change
    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const search = event?.target?.value;
        setSearchTerm(search);

        if (search?.length >= 3) {
            const filtered = rows?.filter((row) =>
                ["rfqID", "rfqName"].some(
                    (key) =>
                        typeof row[key] === "string" &&
                        row[key].toLowerCase().includes(search.toLowerCase())
                )
            );
            setFilteredRows(filtered);
        } else {
            setFilteredRows(rows);
        }
    };

    const getFromValue = () => {
        if (sourcingManager() || sourcingManagerHead()) {
            return "CompanyRfq";
        }
        return "CompanyRfq";
    };

    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [searchTerm]);
    const industryIcons = {
        "Oil & Gas": oligasIcn,
        "Power & Transmission": power,
        "EV/Automotive": evAutoIcn,
        "Industrial Products": industry,
        "Aerospace & Defence": aerospace
    };
    const IndustryTypeCell = ({
        value,
        isIndustryType,
        onChipClick
    }: {
        isIndustryType?: boolean;
        value: string | string[];
        onChipClick?: (type: string) => void;
    }) => {
        const [expanded, setExpanded] = useState(false);
        const types = Array.isArray(value) ? value : value?.split(", ") || [];

        const displayedTypes = expanded ? types : types.slice(0, 2);
        const remainingCount = types.length - 2;

        const handleChipClick = (type: string) => {
            if (!expanded) setExpanded(true); // expand on first click
            onChipClick?.(type); // trigger drawer or any external action
        };

        return (
            <Box
                sx={{
                    gap: 0.5,
                    alignItems: "center",
                    height: "100%",
                    margin: "5px 0 3px"
                }}
            >
                {displayedTypes?.map((type, idx) =>
                    type ? (
                        <Chip
                            key={idx}
                            size="small"
                            label={type}
                            sx={{ margin: "5px 0px 0px 5px" }}
                            onClick={() => handleChipClick(type)}
                            avatar={
                                isIndustryType && industryIcons[type] ? (
                                    <img
                                        src={`${industryIcons[type]}`}
                                        style={{ width: 15, height: 15 }}
                                    />
                                ) : null
                            }
                        />
                    ) : (
                        "-"
                    )
                )}
                {!expanded && remainingCount > 0 && (
                    <Chip
                        size="small"
                        label={`+${remainingCount}`}
                        sx={{ cursor: "pointer", margin: "5px 0px 0px 5px" }}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setExpanded(true);
                        }}
                    />
                )}
                {expanded && (
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setExpanded(false);
                        }}
                        sx={{ margin: "5px 0px 0px 5px" }}
                    >
                        <CancelIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>
        );
    };

    const IndustryCell = ({
        value,
        isIndustryType
    }: {
        value?: string | string[];
        isIndustryType?: boolean;
    }) => {
        const types = Array.isArray(value) ? value : value?.split(", ") || [];

        const firstType = types[0];

        if (!firstType) return <>-</>;

        return (
            <Chip
                size="small"
                label={firstType}
                sx={{ marginLeft: "5px" }}
                avatar={
                    isIndustryType && industryIcons[firstType] ? (
                        <img
                            src={industryIcons[firstType]}
                            alt={firstType}
                            style={{ width: 15, height: 15 }}
                        />
                    ) : null
                }
            />
        );
    };

    const PartTypeCell = ({ value }: { value?: string[] }) => {
        // console.log(value);
        const [expanded, setExpanded] = useState(false);
        const types = value || [];

        const displayedTypes = expanded ? types : types.slice(0, 2);
        const remainingCount = types?.length - 2;

        return (
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 0,
                    alignItems: "center",
                    height: "100%",
                    padding: "5px 0 5px"
                }}
            >
                {displayedTypes?.map((part, idx) => (
                    <Chip
                        key={idx}
                        size="small"
                        label={part || "-"}
                        sx={{ margin: "5px 0px 0px 5px" }}
                    />
                ))}

                {!expanded && remainingCount > 0 && (
                    <Chip
                        size="small"
                        label={`+${remainingCount}`}
                        sx={{ cursor: "pointer", margin: "5px 0px 0px 5px" }}
                        onClick={() => setExpanded(true)}
                    />
                )}
                {expanded && (
                    <IconButton
                        size="small"
                        onClick={() => setExpanded(false)}
                        sx={{ margin: "5px 0px 0px 5px" }}
                    >
                        <CancelIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>
        );
    };
    const getCurrencyIcon = (currency) => {
        switch (currency) {
            case "INR":
                return <CurrencyRupeeIcon sx={{ fontSize: "0.875rem" }} />;
            case "USD":
                return <AttachMoneyIcon sx={{ fontSize: "0.875rem" }} />;
            case "EUR":
                return <EuroIcon sx={{ fontSize: "0.875rem" }} />;
            default:
                return null;
        }
    };
    function parseCustomDate(dateStr: string) {
        return dayjs(dateStr, "DD-MMM-YYYY HH:mm:ss").toDate();
    }

    const isHighValueRfq = (row) => {
        const { preferredCurrency, totalOrderValue } = row;

        return (
            (preferredCurrency === "INR" && totalOrderValue >= 5000000) ||
            (preferredCurrency === "EUR" && totalOrderValue >= 50000) ||
            (preferredCurrency === "USD" && totalOrderValue >= 50000)
        );
    };

    const columns: GridColDef[] = [
        {
            field: "rfqID",
            headerName: "CORFQ ID",
            width: 120,
            disableColumnMenu: true,
            renderCell: (params) => {
                const addedOnValue = params.row.addedOn
                    ? new Date(params.row.addedOn).getTime()
                    : 0;
                const nowValue = new Date().getTime();

                const hoursDiff = (nowValue - addedOnValue) / (1000 * 60 * 60);
                const daysExceeded = Math.floor(hoursDiff / 24);
                const status = params.row.status;
                const isKAMHead = accountManagerHead();
                const limitExceeded =
                    ((isKAMHead && status === "KAM Head Review Pending") ||
                        (!isKAMHead && status === "Pending")) &&
                    hoursDiff > 72;
                // console.log("limitExceeded", limitExceeded);
                const payload = {
                    rfqData: params?.row,
                    from: getFromValue()
                };
                return (
                    <>
                        <Link
                            to="/layout/CURFQDetails"
                            target="_blank"
                            state={{ payload }}
                            onClick={() => {
                                localStorage.setItem(
                                    "CURFQDetails",
                                    JSON.stringify(payload)
                                );
                            }}
                            style={{ textDecoration: "none" }}
                        >
                            {params?.value}
                        </Link>
                        {limitExceeded && (
                            <Tooltip
                                title={
                                    <>
                                        Waiting for Verdict for {daysExceeded}{" "}
                                        day
                                        {daysExceeded > 1 ? "s" : ""}
                                    </>
                                }
                            >
                                <ErrorOutlineOutlinedIcon
                                    color="error"
                                    sx={{ fontSize: "1rem", marginLeft: "5px" }}
                                />
                            </Tooltip>
                        )}
                    </>
                );
            }
        },
        {
            field: "rfqName",
            headerName: "CORFQ Name",
            width: 200,
            disableColumnMenu: true,
            cellClassName: (params) => {
                return isHighValueRfq(params?.row) ? "rfq-high-value-cell" : "";
            },
            renderCell: (params) => {
                const highValue = isHighValueRfq(params?.row);
                const payload = {
                    rfqData: params?.row,
                    from: getFromValue()
                };
                return (
                    <>
                        {highValue && (
                            <>
                                <div className="highlightChip">
                                    High value{" "}
                                    <TrendingUpIcon sx={{ fontSize: "1rem" }} />
                                </div>
                            </>
                        )}
                        <Link
                            to="/layout/CURFQDetails"
                            target="_blank"
                            // state={{ rfqData: params?.row }}
                            state={{ payload }}
                            onClick={() => {
                                localStorage.setItem(
                                    "CURFQDetails",
                                    JSON.stringify(payload)
                                );
                            }}
                            style={{
                                textDecoration: "none",
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                alignItems: "center"
                            }}
                        >
                            <span>{params?.value}</span>
                            {!accountManager() && params.row.isNew && (
                                <CircleIcon
                                    sx={{ fontSize: "12px", color: " #1976d2" }}
                                />
                            )}
                        </Link>
                    </>
                );
            }
        },
        {
            field: "companyName",
            headerName: "Company Name",
            minWidth: 250,
            disableColumnMenu: true,
            renderCell: (params) => {
                const name = params.value || "";
                const truncatedName = name;
                const logoUrl = params.row.companyLogo
                    ? generateCompanyLogo(
                          params.row.companyRecId,
                          params.row.companyLogo
                      )
                    : defaultlogo;
                const payload = {
                    companyRecId: params.row?.companyRecId,
                    compDetails: params.row,
                    from: getFromValue()
                };
                return (
                    <Link
                        to="/layout/CompanyProfilePage"
                        target="_blank"
                        state={{ payload }}
                        onClick={() => {
                            localStorage.setItem(
                                "CompanyProfilePage",
                                JSON.stringify(payload)
                            );
                        }}
                        style={{ textDecoration: "none" }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                // overflow: "hidden",
                                // textOverflow: "ellipsis",
                                // whiteSpace: "nowrap",
                                height: "100%",
                                cursor: "pointer"
                            }}
                        >
                            {logoUrl && (
                                <img
                                    src={logoUrl}
                                    alt={name}
                                    width={28}
                                    height={28}
                                    style={{
                                        borderRadius: "50%",
                                        border: "1px solid #D8D8D8"
                                    }}
                                />
                            )}
                            <Typography variant="body2" className="hoverClr">
                                {truncatedName}
                            </Typography>
                        </Box>
                    </Link>
                );
            }
        },

        {
            field: "marginRange",
            headerName: "Margin Range",
            width: 180,
            disableColumnMenu: true,
            renderCell: (params) => {
                const value = params?.value;
                const parts = value?.split(" to ");

                return (
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Chip label={parts && parts[0]} size="small" />
                        <Typography variant="body2" fontWeight={500}>
                            -
                        </Typography>
                        <Chip label={parts && parts[1]} size="small" />
                    </Stack>
                );
            }
        },

        // {
        //   field: "partDetails",
        //   headerName: "List of parts",
        //   width: 200,
        //   disableColumnMenu: true,
        //   renderCell: (params) => <PartTypeCell value={params?.value} />,
        // },

        {
            field: "rfqStartDate",
            headerName: "CORFQ Start Date ",
            width: 150,
            disableColumnMenu: true
        },

        {
            field: "rfqEndDate",
            headerName: "CORFQ End Date",
            width: 150,
            disableColumnMenu: true
        },
        {
            field: "totalOrderValue",
            headerName: "Total Order Value",
            width: 150,
            disableColumnMenu: true,
            renderCell: (params) => {
                const value = params.value;
                const currency = params?.row?.preferredCurrency;
                const formattedValue = formatCurrencyValue(value, currency);
                return (
                    <>
                        <div style={{ display: "block" }}>
                            <Typography
                                variant="body2"
                                display="flex"
                                alignItems="center"
                            >
                                {getCurrencyIcon(
                                    params?.row?.preferredCurrency
                                )}
                                <span style={{ paddingLeft: "5px" }}>
                                    {formattedValue}
                                </span>
                                <Tooltip title={params?.row?.pricetype}>
                                    <IconButton>
                                        <InfoOutlinedIcon
                                            style={{ fontSize: "16px" }}
                                        />
                                    </IconButton>
                                </Tooltip>
                            </Typography>
                            <Typography
                                variant="caption"
                                color="text.secondary"
                                display="block"
                            >
                                {params?.row?.preferredCurrency}
                            </Typography>
                        </div>
                    </>
                );
            }
        },

        {
            field: "industryType",
            headerName: "Industry type",
            width: 200,
            disableColumnMenu: true,
            renderCell: (params) => (
                <IndustryCell value={params.value} isIndustryType={true} />
            )
        },

        // {
        //   field: "mandatoryCertifications",
        //   headerName: "Mandatory Certifications",
        //   width: 200,
        //   disableColumnMenu: true,
        //   renderCell: (params) => (
        //     <IndustryTypeCell
        //       value={params.value}
        //       onChipClick={() => handleOpenDrawer(params.row)}
        //     />
        //   ),
        // },
        {
            field: "incoTerms",
            headerName: "Inco Terms",
            width: 150,
            disableColumnMenu: true
        },

        ...(!accountManager()
            ? [
                  {
                      field: "keyAccountManager",
                      headerName: "Key Account Manager",
                      width: 250,
                      disableColumnMenu: true,
                      renderCell: (params) => {
                          const name = params.value || "";
                          return (
                              <Grid
                                  container
                                  spacing={2}
                                  alignItems="center"
                                  width="100%"
                              >
                                  <Grid size={{ xs: 2, md: 2 }}>
                                      <img
                                          src={
                                              generatProfilePicUrl(
                                                  params.row
                                                      .keyAccountManagerID,
                                                  params.row
                                                      .keyAccountManagerFilePath,
                                                  "Profile_Picture"
                                              ) || ""
                                          }
                                          alt="KAM"
                                          width={28}
                                          height={28}
                                          style={{
                                              marginRight: "5px",
                                              borderRadius: "50%"
                                          }}
                                      />
                                  </Grid>
                                  <Grid size={{ xs: 10, md: 10 }}>
                                      <Typography variant="body2" className="">
                                          {name}
                                      </Typography>
                                  </Grid>
                              </Grid>
                          );
                      }
                  }
              ]
            : []),
        {
            field: "addedOn",
            headerName: "Added On",
            width: 150,
            disableColumnMenu: true
        },

        {
            field: "lastUpdateOn",
            headerName: "Last Updated On",
            width: 150,
            disableColumnMenu: true,
            sortComparator: (v1, v2) =>
                parseCustomDate(v1).getTime() - parseCustomDate(v2).getTime()
        },

        {
            field: "type_of_order",
            headerName: "Type of order",
            width: 150,
            disableColumnMenu: true,
            renderCell: (params) => {
                if (!params?.value) {
                    return "-";
                }
                return (
                    <Chip
                        variant="outlined"
                        label={params?.value}
                        size="small"
                        color={
                            params?.value === "Recurring Order"
                                ? "info"
                                : "warning"
                        }
                    />
                );
            }
        },

        {
            field: "status",
            headerName: "CORFQ Status",
            width: 180,
            disableColumnMenu: true,
            cellClassName: () => "first-pinned-right",
            headerClassName: "first-pinned-right",
            renderCell: (params) => {
                let color:
                    | "default"
                    | "info"
                    | "success"
                    | "error"
                    | "warning"
                    | "primary"
                    | "secondary" = "info"; // Default color

                switch (params.row.status) {
                    case "Approved":
                        color = "success";
                        break;
                    case "Rejected":
                        color = "error";
                        break;
                    case "Partially Approved":
                        color = "warning";
                        break;
                    case "Verdict Not Given":
                        color = "default";
                        break;
                    case "Pending":
                        color = "default";
                        break;
                    case "Approved":
                        color = "success";
                        break;
                    case "Rejected":
                        color = "error";
                        break;
                    case "Approvers Review Pending":
                        color = "warning";
                        break;
                    case "KAM Head Review Pending":
                        color = "warning";
                        break;
                    case "Pending":
                        color = "default";
                        break;
                    default:
                        color = "default";
                    // }
                }
                return (
                    <Chip
                        // label={
                        //   params.row.status === "Rejected"
                        //     ? "Rejected by KAM Head"
                        //     : params.row.status
                        // }
                        label={
                            params.row.status === "Rejected" &&
                            (accountManagerHead() ||
                                accountManager() ||
                                Management())
                                ? "Rejected by KAM Head"
                                : params.row.status
                        }
                        color={color}
                        variant="outlined"
                        size="small"
                        sx={{
                            ...(params?.row?.status ===
                                "Partially Approved" && {
                                borderColor: "#F8B714",
                                color: "#F8B714"
                            }),
                            ...((params?.row?.status === "Pending" ||
                                params?.row?.status ===
                                    "Verdict Not Given") && {
                                border: "1px solid #ccc",
                                color: " #797979"
                            }),
                            ...(params?.row?.status ===
                                "Approvers Review Pending" && {
                                borderColor: "#F8B714",
                                color: "#F8B714"
                            })
                        }}
                    />
                );
            }
        }

        // {
        //   field: "action",
        //   headerName: "Action",
        //   width: 100,
        //   disableColumnMenu: true,
        //   renderCell: (params) => <ActionMenu />,
        // },
    ];

    const ActionMenu = () => {
        const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);

        const handleClick = (event: { currentTarget: any }) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

        return (
            <>
                <IconButton onClick={handleClick}>
                    <MoreVertIcon />
                </IconButton>
                <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    <MenuItem
                        onClick={() => alert("Clicked vd")}
                        sx={{ fontSize: "0.875rem" }}
                    >
                        View Details
                    </MenuItem>
                    <MenuItem
                        onClick={() => alert("Clicked ao")}
                        sx={{ fontSize: "0.875rem" }}
                    >
                        Activate Organisation
                    </MenuItem>
                    <MenuItem
                        onClick={() => alert("Clicked do")}
                        sx={{ fontSize: "0.875rem" }}
                    >
                        Deactivate Organisation
                    </MenuItem>
                </Menu>
            </>
        );
    };

    const finalColumns = columns;

    /**Filter functionality start from here */
    function extractOptions(apiResponse: any[], keyName: string) {
        const section = apiResponse.find((item) => item[keyName]);
        if (!section) return [];

        // Handle keyAccountManager separately as it is a direct array
        if (Array.isArray(section[keyName])) {
            return section[keyName].map((name) => ({
                key: name,
                title: name
            }));
        }

        // Handle objects with choices
        if (section[keyName]?.choices) {
            return section[keyName].choices.map(
                (item: { key: any; link_name: any; value: any }) => ({
                    key: item.key || item.link_name || "unknown_key",
                    title: item.value || item.link_name || "Unknown"
                })
            );
        }

        return [];
    }

    const fetchFilterData = async () => {
        setIsFilterLoading(true);
        try {
            const filterData = await getCompanyRfqMetaFilterData();
            if (filterData?.status) {
                type CompanyType = {
                    company: string[];
                };

                const companyDetails: string[] = Array.from(
                    new Set(rows?.map((item: any) => item?.companyName) ?? [])
                );

                const company: CompanyType[] = [{ company: companyDetails }];

                const apiResponse = filterData?.data;
                const industryOptions = extractOptions(
                    apiResponse,
                    "industryType"
                );
                // const rfqOptions = extractOptions(apiResponse, "rfqName");
                const statusOptions = extractOptions(apiResponse, "rfqStatus");
                const marginOptions = extractOptions(
                    apiResponse,
                    "marginRange"
                );
                const companyOptions = extractOptions(company, "company");
                const keyAccountManagerOptions = extractOptions(
                    apiResponse,
                    "keyAccountManager"
                );
                const obj = {
                    industryOptions,
                    // rfqOptions,
                    statusOptions,
                    marginOptions,
                    companyOptions,
                    keyAccountManagerOptions
                };
                setFilterOptions(obj);
            }
            setIsFilterLoading(false);
        } catch (error) {
            setIsFilterLoading(false);
        }
    };

    const filterData = (
        rows: any[],
        filters: {
            industry: any;
            status: any;
            marginRange: any;
            keyAccountManager: any;
            company: any;
        }
    ) => {
        return rows?.filter(
            (row: {
                industryType: string;
                status: string;
                companyName: string;
                marginRange: string;
                keyAccountManager: string;
            }) => {
                // Convert row values to lowercase arrays for comparison
                const industryArray =
                    row?.industryType?.toLowerCase()?.split(/\s*,\s*/) || [];
                const statusArray =
                    row?.status?.toLowerCase()?.split(/\s*,\s*/) || [];
                const companyArray =
                    row?.companyName?.toLowerCase()?.split(/\s*,\s*/) || [];
                const marginRangeArray =
                    row?.marginRange?.toLowerCase()?.split(/\s*,\s*/) || [];

                const keyAccountManagerArray =
                    row?.keyAccountManager?.toLowerCase()?.split(/\s*,\s*/) ||
                    [];

                // Get filter values, ignore empty ones
                const {
                    industry = [],
                    status = [],
                    company = [],
                    marginRange = [],
                    keyAccountManager = []
                } = filters;

                // Check if each applied filter matches
                const industryMatch =
                    industry?.length === 0 ||
                    industry?.some((ind: string) =>
                        industryArray?.includes(ind.toLowerCase())
                    );

                const statusMatch =
                    status?.length === 0 ||
                    status?.some((sol: string) =>
                        statusArray?.includes(sol.toLowerCase())
                    );
                const companyMatch =
                    company?.length === 0 ||
                    company?.some((cert: string) =>
                        companyArray?.includes(cert.toLowerCase())
                    );
                const marginRangeMatch =
                    marginRange?.length === 0 ||
                    marginRange?.some((m: string) =>
                        marginRangeArray?.includes(m.toLowerCase())
                    );

                const keyAccounManagerMatch =
                    keyAccountManager?.length === 0 ||
                    keyAccountManager?.some((loc: string) =>
                        keyAccountManagerArray.includes(loc.toLowerCase())
                    );

                // **Must match ALL applied filters**
                return (
                    industryMatch &&
                    statusMatch &&
                    companyMatch &&
                    marginRangeMatch &&
                    keyAccounManagerMatch
                );
            }
        );
    };

    const handleApply = async () => {
        setIsApplyFilter(true);
        let filters = {
            industry:
                selectedIndustry?.map((item) => item?.title.toLowerCase()) ||
                [],
            status:
                selectedStatus?.map((item) => item?.title.toLowerCase()) || [],
            marginRange:
                selectedMarginRange?.map((item) => item?.title.toLowerCase()) ||
                [],
            keyAccountManager:
                selectedKeyAccountManager?.map((item) =>
                    item?.title.toLowerCase()
                ) || [],
            company:
                selectedCompany?.map((item) => item?.title.toLowerCase()) || []
        };

        const filteredResults = filterData(rows, filters);
        setFilteredRows(filteredResults);
        setAnchorEl(null);
        setFilteredSelectedIndustry(selectedIndustry);
        setFilteredSelectedCompany(selectedCompany);
        setFilteredSelectedKeyAccountManager(selectedKeyAccountManager);
        setFilteredSelectedMarginRange(selectedMarginRange);
        setFilteredSelectedStatus(selectedStatus);
        if (
            selectedIndustry?.length == 0 &&
            selectedStatus?.length == 0 &&
            selectedMarginRange?.length == 0 &&
            selectedKeyAccountManager?.length == 0 &&
            selectedCompany?.length === 0
        ) {
            setFilteredRows(rows);
            setFilteredSelectedIndustry(selectedIndustry);
            setFilteredSelectedCompany(selectedCompany);
            setFilteredSelectedKeyAccountManager(selectedKeyAccountManager);
            setFilteredSelectedMarginRange(selectedMarginRange);
            setFilteredSelectedStatus(selectedStatus);
        }
    };

    const handleRemoveFilter = (category: string, item: { title: any }) => {
        if (removeFilter == true) {
            setRemoveFilter(false);
        } else {
            setRemoveFilter(true);
        }
        switch (category) {
            case "industry":
                setSelectedIndustry((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;

            case "company":
                setSelectedCompany((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            case "marginRange":
                setSelectedMarginRange((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            case "status":
                setSelectedStatus((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            case "keyAccountManager":
                setSelectedKeyAccountManager((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            default:
                break;
        }
    };

    // Run `handleApply` after any filter changes
    useEffect(() => {
        handleApply();
        if (
            selectedIndustry?.length == 0 &&
            selectedStatus?.length == 0 &&
            selectedMarginRange?.length == 0 &&
            selectedKeyAccountManager?.length == 0 &&
            selectedCompany?.length === 0
        ) {
            setIsApplyFilter(false);
        }
    }, [removeFilter]);

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: "10px" }}>
                <Typography sx={{ fontSize: "14px" }}>
                    <Link
                        to="/layout/Dashboard"
                        style={{
                            color: "#0070BA",
                            fontSize: "14px",
                            textDecoration: "none"
                        }}
                    >
                        Home
                    </Link>
                </Typography>
                {[
                    <>
                        <Typography key="final" sx={{ fontSize: "14px" }}>
                            In Review
                        </Typography>
                    </>
                ]}
            </Breadcrumbs>

            <Typography variant="h5" mb={1}>
                In Review
            </Typography>
            <Box
                sx={{
                    borderRadius: "5px",
                    marginTop: "16px",
                    background: "#fff",
                    padding: "15px"
                }}
            >
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        {rows?.length > 1 && (
                            <Grid container spacing={2}>
                                {/* Search Section */}
                                <Grid size={{ xs: 12, md: 7 }}>
                                    <TextField
                                        label="Search by CORFQ ID & CORFQ Name"
                                        size="small"
                                        variant="outlined"
                                        fullWidth
                                        inputRef={searchInputRef}
                                        value={searchTerm}
                                        onChange={handleSearch}
                                    />
                                </Grid>
                                {/* Filter section */}
                                <Grid
                                    size={{ xs: 12, md: 5 }}
                                    sx={{
                                        color: "grey",
                                        display: "flex",
                                        alignItems: "center"
                                    }}
                                >
                                    <Box>
                                        <IconButton onClick={handleClick}>
                                            <Badge
                                                badgeContent={
                                                    filteredSelectedIndustry?.length +
                                                    filteredSelectedStatus?.length +
                                                    filteredSelectedMarginRange?.length +
                                                    filteredSelectedKeyAccountManager?.length +
                                                    filteredSelectedCompany?.length
                                                }
                                                color="primary"
                                            >
                                                <FilterAltOutlinedIcon />
                                            </Badge>
                                        </IconButton>

                                        <Popper
                                            open={Boolean(anchorEl)}
                                            anchorEl={anchorEl}
                                            placement="bottom-start"
                                            sx={{ zIndex: 13 }}
                                        >
                                            <Paper
                                                ref={popperRef}
                                                sx={{
                                                    p: 2,
                                                    width: 350,
                                                    boxShadow: 3,
                                                    borderRadius: 2
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        fontWeight: "bold",
                                                        mb: 2,
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between"
                                                    }}
                                                >
                                                    Filter{" "}
                                                    <Button
                                                        size="small"
                                                        variant="outlined"
                                                        onClick={handleClearAll}
                                                    >
                                                        CLEAR ALL
                                                    </Button>
                                                </Box>
                                                {!isFilterLoading ? (
                                                    <Box sx={{ mb: 2 }}>
                                                        <Autocomplete
                                                            multiple
                                                            size="small"
                                                            sx={{
                                                                marginBottom:
                                                                    "15px"
                                                            }}
                                                            limitTags={2}
                                                            id="multiple-limit-tags"
                                                            options={[
                                                                ...(filterOptions?.statusOptions ||
                                                                    [])
                                                            ]?.sort((a, b) =>
                                                                a?.title?.localeCompare(
                                                                    b?.title
                                                                )
                                                            )}
                                                            value={
                                                                selectedStatus
                                                            }
                                                            onChange={(
                                                                event,
                                                                newValue
                                                            ) =>
                                                                setSelectedStatus(
                                                                    newValue ||
                                                                        []
                                                                )
                                                            }
                                                            // getOptionLabel={(option) => option?.title || ""}
                                                            getOptionLabel={(
                                                                option
                                                            ) => {
                                                                const isKamRole =
                                                                    accountManager() ||
                                                                    accountManagerHead() ||
                                                                    Management();

                                                                if (
                                                                    option?.title ===
                                                                        "Rejected" &&
                                                                    isKamRole
                                                                ) {
                                                                    return "Rejected by KAM Head";
                                                                }
                                                                return (
                                                                    option?.title ||
                                                                    ""
                                                                );
                                                            }}
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="CORFQ Status"
                                                                    placeholder="Select CORFQ Status"
                                                                />
                                                            )}
                                                        />
                                                        <Autocomplete
                                                            multiple
                                                            limitTags={2}
                                                            sx={{
                                                                marginBottom:
                                                                    "15px"
                                                            }}
                                                            size="small"
                                                            id="multiple-limit-tags"
                                                            value={
                                                                selectedIndustry
                                                            }
                                                            onChange={(
                                                                event,
                                                                newValue
                                                            ) =>
                                                                setSelectedIndustry(
                                                                    newValue ||
                                                                        []
                                                                )
                                                            }
                                                            options={[
                                                                ...(filterOptions?.industryOptions ||
                                                                    [])
                                                            ]?.sort((a, b) =>
                                                                a?.title?.localeCompare(
                                                                    b?.title
                                                                )
                                                            )}
                                                            getOptionLabel={(
                                                                option
                                                            ) =>
                                                                option?.title ||
                                                                ""
                                                            }
                                                            renderOption={(
                                                                props,
                                                                option
                                                            ) => (
                                                                <li
                                                                    {...props}
                                                                    style={{
                                                                        display:
                                                                            "flex",
                                                                        alignItems:
                                                                            "center",
                                                                        gap: 10
                                                                    }}
                                                                >
                                                                    <Typography>
                                                                        {
                                                                            option.title
                                                                        }
                                                                    </Typography>
                                                                </li>
                                                            )}
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Industry"
                                                                    placeholder="Select Industry Type"
                                                                />
                                                            )}
                                                        />
                                                        <Autocomplete
                                                            multiple
                                                            size="small"
                                                            sx={{
                                                                marginBottom:
                                                                    "15px"
                                                            }}
                                                            limitTags={2}
                                                            id="multiple-limit-tags"
                                                            options={[
                                                                ...(filterOptions?.companyOptions ||
                                                                    [])
                                                            ]?.sort((a, b) =>
                                                                a?.title?.localeCompare(
                                                                    b?.title
                                                                )
                                                            )}
                                                            value={
                                                                selectedCompany
                                                            }
                                                            onChange={(
                                                                event,
                                                                newValue
                                                            ) =>
                                                                setSelectedCompany(
                                                                    newValue ||
                                                                        []
                                                                )
                                                            }
                                                            getOptionLabel={(
                                                                option
                                                            ) =>
                                                                option?.title ||
                                                                ""
                                                            }
                                                            isOptionEqualToValue={(
                                                                option,
                                                                value
                                                            ) =>
                                                                option.title ===
                                                                value?.title
                                                            }
                                                            //  disabled={(selectedIndustry || []).length == 0}
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Company"
                                                                    placeholder="Select Company"
                                                                />
                                                            )}
                                                        />
                                                        <Autocomplete
                                                            multiple
                                                            size="small"
                                                            sx={{
                                                                marginBottom:
                                                                    "15px"
                                                            }}
                                                            limitTags={2}
                                                            id="multiple-limit-tags"
                                                            options={[
                                                                ...(filterOptions?.marginOptions ||
                                                                    [])
                                                            ]?.sort((a, b) =>
                                                                a?.title?.localeCompare(
                                                                    b?.title
                                                                )
                                                            )}
                                                            getOptionLabel={(
                                                                option
                                                            ) =>
                                                                option?.title ||
                                                                ""
                                                            }
                                                            value={
                                                                selectedMarginRange
                                                            }
                                                            onChange={(
                                                                event,
                                                                newValue
                                                            ) =>
                                                                setSelectedMarginRange(
                                                                    newValue ||
                                                                        []
                                                                )
                                                            }
                                                            isOptionEqualToValue={(
                                                                option,
                                                                value
                                                            ) =>
                                                                option.title ===
                                                                value?.title
                                                            }
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Margin Range"
                                                                    placeholder="Select Margin Range"
                                                                />
                                                            )}
                                                        />

                                                        {(accountManagerHead() ||
                                                            sourcingManagerHead() ||
                                                            qualityManagerHead() ||
                                                            NPDManagerHead() ||
                                                            productionManagerHead() ||
                                                            Management()) && (
                                                            <Autocomplete
                                                                multiple
                                                                size="small"
                                                                sx={{
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                                limitTags={2}
                                                                id="multiple-limit-tags"
                                                                options={[
                                                                    ...(filterOptions?.keyAccountManagerOptions ||
                                                                        [])
                                                                ]?.sort(
                                                                    (a, b) =>
                                                                        a?.title?.localeCompare(
                                                                            b?.title
                                                                        )
                                                                )}
                                                                getOptionLabel={(
                                                                    option
                                                                ) =>
                                                                    option?.title ||
                                                                    ""
                                                                }
                                                                value={
                                                                    selectedKeyAccountManager
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newValue
                                                                ) =>
                                                                    setSelectedKeyAccountManager(
                                                                        newValue ||
                                                                            []
                                                                    )
                                                                }
                                                                isOptionEqualToValue={(
                                                                    option,
                                                                    value
                                                                ) =>
                                                                    option.title ===
                                                                    value?.title
                                                                }
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Key Account Manager"
                                                                        placeholder="Select Key Account Manager"
                                                                    />
                                                                )}
                                                            />
                                                        )}
                                                    </Box>
                                                ) : (
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        height="50vh"
                                                    >
                                                        <ThreeDot
                                                            color="#1976d2"
                                                            size="medium"
                                                            text=""
                                                            textColor=""
                                                        />
                                                    </Box>
                                                )}
                                                {/* Apply / Cancel Buttons */}
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between",
                                                        mt: 2
                                                    }}
                                                >
                                                    <Button
                                                        onClick={handleClose}
                                                        color="error"
                                                    >
                                                        CANCEL
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleApply}
                                                    >
                                                        APPLY
                                                    </Button>
                                                </Box>
                                            </Paper>
                                        </Popper>
                                    </Box>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        {value === "1" && selectedRows?.length > 0 && (
                            <>
                                <div style={{ float: "right" }}>
                                    <Button
                                        variant="contained"
                                        color="error"
                                        size="small"
                                        disabled={isButtonDisable}
                                        onClick={handleClickOpenDialog}
                                        sx={{ marginRight: "10px" }}
                                    >
                                        Reject
                                    </Button>
                                    <Dialog
                                        open={openDialog}
                                        onClose={handleCloseDialog}
                                        maxWidth={maxWidth}
                                        fullWidth
                                        aria-labelledby="responsive-dialog-title"
                                    >
                                        <DialogTitle id="responsive-dialog-title">
                                            {"Reason for Rejection"}
                                        </DialogTitle>
                                        <div style={{ padding: "0 20px" }}>
                                            <TextField
                                                id="outlined-multiline-static"
                                                label="Add your comments"
                                                multiline
                                                rows={4}
                                                value={reasonForRejection}
                                                onChange={(e) =>
                                                    setReasonForRejection(
                                                        e?.target?.value
                                                    )
                                                }
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                fullWidth
                                            />
                                        </div>
                                        <DialogActions>
                                            <Button
                                                autoFocus
                                                color="error"
                                                onClick={handleCloseDialog}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                disabled={
                                                    reasonForRejection?.length <=
                                                    0
                                                }
                                                autoFocus
                                            >
                                                Submit
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                    <Button
                                        variant="contained"
                                        color="success"
                                        size="small"
                                        disabled={isButtonDisable}
                                    >
                                        Accept
                                    </Button>
                                </div>
                            </>
                        )}
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                        {/* Selected Filters as Chips */}
                        {isApplyFilter == true && (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 1
                                }}
                                mb={2}
                            >
                                {filteredSelectedIndustry?.map(
                                    (item, index) => (
                                        <Chip
                                            key={`industry-${index}`}
                                            label={item?.title}
                                            onDelete={() =>
                                                handleRemoveFilter(
                                                    "industry",
                                                    item
                                                )
                                            }
                                            size="small"
                                        />
                                    )
                                )}

                                {filteredSelectedCompany?.map((item, index) => (
                                    <Chip
                                        key={`company-${index}`}
                                        label={item?.title}
                                        onDelete={() =>
                                            handleRemoveFilter("company", item)
                                        }
                                        size="small"
                                    />
                                ))}
                                {filteredSelectedMarginRange?.map(
                                    (item, index) => (
                                        <Chip
                                            key={`machine-${index}`}
                                            label={item?.title}
                                            onDelete={() =>
                                                handleRemoveFilter(
                                                    "marginRange",
                                                    item
                                                )
                                            }
                                            size="small"
                                        />
                                    )
                                )}
                                {filteredSelectedStatus?.map((item, index) => (
                                    <Chip
                                        key={`status-${index}`}
                                        label={
                                            (accountManager() ||
                                                accountManagerHead() ||
                                                Management()) &&
                                            item.title === "Rejected"
                                                ? "Rejected by KAM Head"
                                                : item.title
                                        }
                                        onDelete={() =>
                                            handleRemoveFilter("status", item)
                                        }
                                        size="small"
                                    />
                                ))}
                                {filteredSelectedKeyAccountManager?.map(
                                    (item, index) => (
                                        <Chip
                                            key={`keyAccountManager-${index}`}
                                            label={item.title}
                                            onDelete={() =>
                                                handleRemoveFilter(
                                                    "keyAccountManager",
                                                    item
                                                )
                                            }
                                            size="small"
                                        />
                                    )
                                )}
                                {/* Clear All Button - Show only when filters exist */}
                                {filteredSelectedIndustry?.length +
                                    filteredSelectedStatus?.length +
                                    filteredSelectedMarginRange?.length +
                                    filteredSelectedKeyAccountManager?.length +
                                    filteredSelectedCompany?.length >
                                    0 && (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={handleClearAllChip}
                                        sx={{
                                            fontSize: ".75rem !important",
                                            lineHeight: "1",
                                            borderRadius: "30px"
                                        }}
                                    >
                                        CLEAR ALL
                                    </Button>
                                )}
                            </Box>
                        )}
                    </Grid>
                </Grid>
                <Paper
                    sx={{
                        // height: 400,
                        height:
                            filteredRows?.length > 4
                                ? "62vh"
                                : filteredRows?.length > 0
                                  ? "auto"
                                  : "62vh",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    {!isLoading ? (
                        filteredRows?.length > 0 ? (
                            <DataGridPro
                                // autoHeight
                                pinnedColumns={pinnedColumns}
                                onPinnedColumnsChange={
                                    handlePinnedColumnsChange
                                }
                                getRowHeight={() => "auto"}
                                rows={filteredRows}
                                columns={finalColumns}
                                pagination={filteredRows?.length > 10}
                                paginationModel={paginationModel}
                                onPaginationModelChange={setPaginationModel}
                                pageSizeOptions={[10, 20]}
                                disableRowSelectionOnClick={true}
                                columnVisibilityModel={{
                                    lastUpdateOn:
                                        accountManager() ||
                                        accountManagerHead() ||
                                        Management()
                                }}
                                initialState={{
                                    sorting: {
                                        sortModel: [
                                            {
                                                field: "lastUpdateOn",
                                                sort: "desc"
                                            }
                                        ]
                                    }
                                }}
                                sx={{
                                    width: "100%",
                                    "& .MuiDataGrid-columnHeaderTitleContainer":
                                        {
                                            "& .MuiDataGrid-sortIcon": {
                                                opacity: "1 !important",
                                                visibility: "visible !important"
                                            }
                                        },
                                    "& .MuiDataGrid-cell": {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    "& .MuiDataGrid-scrollbarFiller--pinnedRight":
                                        {
                                            backgroundColor: "#F4F4F4!important"
                                        }
                                }}
                            />
                        ) : (
                            <>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: "8px",
                                        padding: "20px"
                                    }}
                                >
                                    {(searchTerm &&
                                        filteredRows?.length == 0) ||
                                    (isApplyFilter &&
                                        filteredRows?.length == 0) ? (
                                        "No Options available"
                                    ) : (
                                        <>
                                            <img
                                                src={emptyImage}
                                                alt="Empty"
                                                width={"300px"}
                                            />
                                            <b style={{ color: "#0009" }}>
                                                No CORFQs Captured yet
                                            </b>
                                        </>
                                    )}
                                </div>
                            </>
                        )
                    ) : (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="50vh"
                        >
                            <ThreeDot
                                color=" #1976d2"
                                size="medium"
                                text=""
                                textColor=""
                            />
                        </Box>
                    )}
                </Paper>
                <CertificationDrawerInReview
                    open={openDrawer}
                    onClose={handleCloseDrawer}
                    selectedPartner={selectedRow}
                />
            </Box>
        </>
    );
};
